import { useCallback, useEffect, useState } from "react";
import { clearCall, pendingCall, type CallRelation } from "./callPrompt";

/**
 * Whether to ask "Gesprek met … gehad?" on this relation's page. True on mount when a call to
 * this relation is pending (the user came back to the page), or when the tab becomes visible
 * again after the tap. Not right after the tap while the page never hid.
 */
export function useCallPrompt(relation: Pick<CallRelation, "type" | "id">): {
  visible: boolean;
  dismiss: () => void;
} {
  const { type, id } = relation;
  const [visible, setVisible] = useState(() => pendingCall(type, id) !== null);

  useEffect(() => {
    function onVisibility() {
      if (document.visibilityState === "visible")
        setVisible(pendingCall(type, id) !== null);
    }
    document.addEventListener("visibilitychange", onVisibility);
    return () => document.removeEventListener("visibilitychange", onVisibility);
  }, [type, id]);

  const dismiss = useCallback(() => {
    clearCall();
    setVisible(false);
  }, []);
  return { visible, dismiss };
}
